import { render, staticRenderFns } from "./crossoverActivitiesList.vue?vue&type=template&id=039bf576"
import script from "./crossoverActivitiesList.vue?vue&type=script&lang=js"
export * from "./crossoverActivitiesList.vue?vue&type=script&lang=js"
import style0 from "./crossoverActivitiesList.vue?vue&type=style&index=0&id=039bf576&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports